import { memo, useState } from 'react';

import { Button, Flex, Radio } from 'antd';

import { FilterFilled, SettingFilled } from '@ant-design/icons';
import classnames from 'classnames';

import { TABLE_SIZE } from '../../components/AppTable/constants';
import AppSearch from '../../components/Search/Search';
import SectionHeader from '../../components/SectionHeader';

import AppDropdown from '../../views/ui-components/AppDropdown';
import MultiSelectDropdown from '../../views/ui-components/MultiSelectDropdown';

import styles from './controls.module.scss';

function AppTableControls({
  actions,
  columns,
  description,
  filterable = false,
  headerClass,
  searchDefaultValue,
  searchPlaceholder = 'Search',
  searchable = true,
  settings = true,
  tableId,
  title,
  handleFilters,
  handleTableSize,
  handleCheckedList,
  handleSearchChange,
  handleResetSettings
}) {
  const [size, setSize] = useState(TABLE_SIZE.SM);
  const [isSettingsOpen, setSettings] = useState(false);

  function choseVisibleColumns(columns) {
    handleCheckedList(columns);
  }

  function choseTableSize(size) {
    setSize(size);
    handleTableSize(size);
  }

  function toggleSettings() {
    setSettings(prevState => !prevState);
  }

  return (
    <>
      <Flex wrap align="center" justify="space-between" gap="small" className={classnames(headerClass)}>
        <SectionHeader title={title} subtitle={description} />
        <Flex className={styles.controls} align="center" gap="small" justify="end" vertical={false}>
          {searchable && (
            <AppSearch
              id="search"
              defaultValue={searchDefaultValue}
              placeholder={searchPlaceholder}
              handleChange={handleSearchChange}
            />
          )}

          <Flex className={styles['controls-buttons']} gap="small" justify="end" align="center">
            {!!actions?.length && <AppDropdown label="Actions" items={actions} />}

            {settings && (
              <Button color="primary" size="large" variant="solid" icon={<SettingFilled />} onClick={toggleSettings}>
                Settings
              </Button>
            )}

            {filterable && (
              <Button color="primary" size="large" variant="solid" icon={<FilterFilled />} onClick={handleFilters}>
                Filters
              </Button>
            )}
          </Flex>
        </Flex>
      </Flex>
      {settings && isSettingsOpen && (
        <Flex wrap justify="end" gap="small" className="pb-2">
          <Radio.Group
            buttonStyle="solid"
            className="custom-radio-group d-flex flex-nowrap"
            optionType="button"
            value={size}
            onChange={e => choseTableSize(e.target.value)}>
            <Radio.Button value={TABLE_SIZE.SM}>Small</Radio.Button>
            <Radio.Button value={TABLE_SIZE.MD}>Medium</Radio.Button>
            <Radio.Button value={TABLE_SIZE.LG}>Large</Radio.Button>
          </Radio.Group>

          <MultiSelectDropdown
            columns={columns}
            onChange={choseVisibleColumns}
            tableId={tableId}
            handleReset={tableId ? handleResetSettings : null}
          />
        </Flex>
      )}
    </>
  );
}

export default memo(AppTableControls);
